import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

class PendingProjectRow extends React.Component {

  constructor(props) {
    super(props);

    this.handleAccept = this.handleAccept.bind(this);
    this.handleDecline = this.handleDecline.bind(this);
  }

  handleAccept() {
    this.handleAssignment(true);
  }

  handleDecline() {
    this.handleAssignment(false);
  }

  handleAssignment(accepted) {

    if (this.props.onAccept) {
      this.props.onAccept(this.props.project.id, accepted);
    }
  }

  render() {

    const item = { ...this.props.project.attributes };
    const projectDate = moment(item.launchDate).format("YYYY-MM-DD");
    const returnPath = this.props.returnPath;

    return (
      <tr>
        <td>{projectDate}</td>
        <td>{item.projectNumber}</td>
        <td>{item.projectName}</td>
        <td>{item.complexity}</td>
        <td>{item.companyName}</td>
        <td>{item.projectType}</td>
        <td className="table-buttons">
          <a className="check" onClick={this.handleAccept} data-icon="&#xe906;">check</a>
          <a className="remove" onClick={this.handleDecline} data-icon="&#xe91c;">remove</a>
        </td>
        <td className="table-buttons">
          <Link to={{ pathname: `/projects/${this.props.project.id}/summary`, state: { returnPath } }} data-icon="&#xe900;" data-tooltip="View">view</Link>
        </td>
      </tr>
    );
  }
}

export default PendingProjectRow;



// WEBPACK FOOTER //
// ./src/components/home/PendingProjectRow.js